export const SCRUB_SECONDS = Object.freeze([2, 5, 10, 15, 30]);
export const scrubSeconds = value => SCRUB_SECONDS.includes(value) ? value : 5;
